export default function initStyles() {
  const objectPosition = document.querySelectorAll<HTMLElement>('.js-object-position');
  const isTouchDevice = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
  objectPosition.forEach((el) => {
    const { objectPositionMobile } = el.dataset;
    el.style.setProperty('object-position', (objectPositionMobile && isTouchDevice) ? objectPositionMobile : el.dataset.objectPosition as string);
  })
}